var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_52",
    "data-name": "\\uADF8\\uB8F9 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169.785,
    height: 48,
    viewBox: "0 0 169.785 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_33",
    "data-name": "\\uC0AC\\uAC01\\uD615 33",
    width: 169.785,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33",
    "data-name": "\\uD328\\uC2A4 33",
    d: "M598.294,0l-4.112,4.121,11.573,11.565L594.182,27.265l4.112,4.107,15.684-15.685Z",
    transform: "translate(-594.182)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -7.392,
    y1: 1.547,
    x2: -7.38,
    y2: 1.547,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#00437b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063b0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34",
    "data-name": "\\uD328\\uC2A4 34",
    d: "M616.872,85.378l15.679,15.7,4.112-4.122L625.091,85.378l11.572-11.566L632.551,69.7Z",
    transform: "translate(-616.872 -69.695)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -7.677,
    y1: 1,
    x2: -7.664,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbe1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fa9e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36a10"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_45",
    "data-name": "\\uADF8\\uB8F9 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_44",
    "data-name": "\\uADF8\\uB8F9 44",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7",
    "data-name": "\\uD328\\uC2A4 7",
    d: "M355.36,78.363a6.947,6.947,0,0,0-2.116-1.641,6.006,6.006,0,0,0-2.836-.652,5.837,5.837,0,0,0-2.743.652,6.982,6.982,0,0,0-2.111,1.641,7.129,7.129,0,0,0-1.313,2.474,10.3,10.3,0,0,0-.46,3.1,9.83,9.83,0,0,0,.46,3.051,7.045,7.045,0,0,0,1.313,2.479,6.85,6.85,0,0,0,2.111,1.66,5.78,5.78,0,0,0,2.743.657,5.948,5.948,0,0,0,2.836-.657,6.816,6.816,0,0,0,2.116-1.66,7.217,7.217,0,0,0,1.264-2.479,10.126,10.126,0,0,0,.451-3.051,10.608,10.608,0,0,0-.451-3.1,7.3,7.3,0,0,0-1.264-2.474m-4.908,8.649a3.16,3.16,0,1,1,3.159-3.159,3.158,3.158,0,0,1-3.159,3.159",
    transform: "translate(-260.065 -57.547)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8",
    "data-name": "\\uD328\\uC2A4 8",
    d: "M433.28,72.058h-4.114v17.6h1.523c1.729,0,2.591-1.117,2.591-3.4Z",
    transform: "translate(-324.658 -54.511)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_9",
    "data-name": "\\uD328\\uC2A4 9",
    d: "M400.842,72.058h-4.364v6.73h-3.517v1.2c.024,1.6.9,2.41,2.194,2.41h1.323l.019,6.294h1.71c1.729,0,2.591-.7,2.591-2.978V72.232c.03-.108.044-.174.044-.174",
    transform: "translate(-297.269 -54.511)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10",
    "data-name": "\\uD328\\uC2A4 10",
    d: "M15.7,10.962H19.01c1.337,0,2.248.428,2.248,1.736a1.572,1.572,0,0,1-.96,1.479,1.7,1.7,0,0,1,1.293,1.775c0,1.423-1.215,2.037-2.483,2.037H15.7ZM17.247,13.8h1.567c.539,0,.945-.245.945-.83,0-.664-.514-.813-1.063-.813h-1.45Zm0,2.98H18.9c.612,0,1.141-.193,1.141-.923s-.451-1-1.112-1H17.247Z",
    transform: "translate(-11.876 -8.293)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11",
    "data-name": "\\uD328\\uC2A4 11",
    d: "M48.374,24.008H47.041V23.3h-.029a1.834,1.834,0,0,1-1.558.843c-1.484,0-1.856-.833-1.856-2.1V18.916h1.4v2.875c0,.833.245,1.252.9,1.252.754,0,1.082-.431,1.082-1.462V18.916h1.4Z",
    transform: "translate(-32.981 -14.31)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12",
    "data-name": "\\uD328\\uC2A4 12",
    d: "M67.9,21.911c.01.6.514.845,1.073.845.4,0,.911-.16.911-.647,0-.419-.578-.575-1.582-.779-.8-.181-1.616-.465-1.616-1.371,0-1.3,1.122-1.636,2.219-1.636s2.131.382,2.244,1.629H69.82c-.039-.536-.456-.691-.96-.691-.313,0-.779.059-.779.485,0,.487.794.558,1.587.745.818.2,1.616.492,1.616,1.435,0,1.342-1.161,1.766-2.322,1.766-1.185,0-2.337-.433-2.4-1.78Z",
    transform: "translate(-50.358 -13.861)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_13",
    "data-name": "\\uD328\\uC2A4 13",
    d: "M88.569,20.04c.083-1.318,1.254-1.717,2.39-1.717,1.019,0,2.243.23,2.243,1.447v2.647a2.684,2.684,0,0,0,.171,1.141h-1.42a2.165,2.165,0,0,1-.093-.5,2.347,2.347,0,0,1-1.714.632c-.965,0-1.734-.478-1.734-1.528,0-1.149.867-1.416,1.734-1.536.852-.137,1.656-.1,1.656-.676,0-.6-.416-.691-.906-.691-.534,0-.877.216-.926.779ZM91.8,21.064a2.608,2.608,0,0,1-1.166.294c-.431.1-.823.235-.823.752s.407.647.852.647A1.043,1.043,0,0,0,91.8,21.585Z",
    transform: "translate(-66.882 -13.861)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_14",
    "data-name": "\\uD328\\uC2A4 14",
    d: "M112.509,18.468h1.332v.708h.034a1.8,1.8,0,0,1,1.553-.852c1.484,0,1.861.845,1.861,2.1V23.56h-1.4V20.687c0-.847-.24-1.256-.9-1.256-.754,0-1.083.416-1.083,1.457V23.56h-1.4Z",
    transform: "translate(-85.111 -13.862)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_15",
    "data-name": "\\uD328\\uC2A4 15",
    d: "M152.043,12.26h-2.1v-1.3H155.7v1.3h-2.106v5.731h-1.548Z",
    transform: "translate(-113.429 -8.292)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16",
    "data-name": "\\uD328\\uC2A4 16",
    d: "M173.792,18.323a2.506,2.506,0,0,1,2.64,2.692,2.635,2.635,0,1,1-5.27,0,2.5,2.5,0,0,1,2.63-2.692m0,4.318c.955,0,1.239-.82,1.239-1.626s-.284-1.638-1.239-1.638-1.23.82-1.23,1.638.284,1.626,1.23,1.626",
    transform: "translate(-129.481 -13.861)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_17",
    "data-name": "\\uD328\\uC2A4 17",
    d: "M201.306,24.008h-1.332V23.3h-.029a1.822,1.822,0,0,1-1.558.843c-1.484,0-1.861-.833-1.861-2.1V18.916h1.4v2.875c0,.833.25,1.252.9,1.252.754,0,1.083-.431,1.083-1.462V18.916h1.4Z",
    transform: "translate(-148.669 -14.31)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_18",
    "data-name": "\\uD328\\uC2A4 18",
    d: "M220.542,18.468h1.327v.948h.019a1.607,1.607,0,0,1,1.93-1.043v1.318a1.887,1.887,0,0,0-.5-.054c-1.023,0-1.376.73-1.376,1.638V23.56h-1.4Z",
    transform: "translate(-166.837 -13.862)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19",
    "data-name": "\\uD328\\uC2A4 19",
    d: "M237.828,12.112h-1.4V10.961h1.4Zm-1.4.786h1.4V17.99h-1.4Z",
    transform: "translate(-178.857 -8.292)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_20",
    "data-name": "\\uD328\\uC2A4 20",
    d: "M247.048,21.911c.01.6.519.845,1.078.845.4,0,.911-.16.911-.647,0-.419-.583-.575-1.587-.779-.808-.181-1.606-.465-1.606-1.371,0-1.3,1.117-1.636,2.209-1.636,1.117,0,2.136.382,2.248,1.629h-1.327c-.044-.536-.46-.691-.96-.691-.318,0-.779.059-.779.485,0,.487.784.558,1.592.745s1.607.492,1.607,1.435c0,1.342-1.161,1.766-2.327,1.766s-2.327-.433-2.38-1.78Z",
    transform: "translate(-185.887 -13.861)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_21",
    "data-name": "\\uD328\\uC2A4 21",
    d: "M268.595,18.468h1.318v.693h.02a1.854,1.854,0,0,1,1.558-.837,1.494,1.494,0,0,1,1.484.852,1.859,1.859,0,0,1,1.538-.852,1.652,1.652,0,0,1,1.861,1.832v3.4h-1.4V20.682c0-.686-.059-1.251-.852-1.251s-.936.649-.936,1.288V23.56h-1.4V20.7c0-.593.039-1.273-.847-1.273-.274,0-.94.179-.94,1.171V23.56h-1.4Z",
    transform: "translate(-203.188 -13.862)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_22",
    "data-name": "\\uD328\\uC2A4 22",
    d: "M318.489,20.04c.078-1.318,1.254-1.717,2.395-1.717,1.014,0,2.234.23,2.234,1.447v2.647a2.656,2.656,0,0,0,.181,1.141h-1.416a1.762,1.762,0,0,1-.1-.5,2.336,2.336,0,0,1-1.709.632c-.97,0-1.734-.478-1.734-1.528,0-1.149.862-1.416,1.734-1.536.852-.137,1.651-.1,1.651-.676,0-.6-.412-.691-.906-.691-.534,0-.882.216-.921.779Zm3.233,1.024a2.608,2.608,0,0,1-1.166.294c-.426.1-.823.235-.823.752s.4.647.852.647a1.04,1.04,0,0,0,1.136-1.171Z",
    transform: "translate(-240.817 -13.861)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M342.434,18.468h1.332v.708h.025a1.827,1.827,0,0,1,1.558-.852c1.489,0,1.857.845,1.857,2.1V23.56h-1.4V20.687c0-.847-.245-1.256-.892-1.256-.759,0-1.087.416-1.087,1.457V23.56h-1.4Z",
    transform: "translate(-259.046 -13.862)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_24",
    "data-name": "\\uD328\\uC2A4 24",
    d: "M369.375,17.349h-.02a1.7,1.7,0,0,1-1.538.774c-1.543,0-2.292-1.31-2.292-2.716a2.373,2.373,0,0,1,2.258-2.652,1.756,1.756,0,0,1,1.5.759h.024V10.962h1.4v7.029h-1.332Zm-1.22-3.541c-.916,0-1.23.8-1.23,1.631,0,.8.363,1.634,1.23,1.634.926,0,1.2-.808,1.2-1.643s-.294-1.621-1.2-1.621",
    transform: "translate(-276.514 -8.293)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_25",
    "data-name": "\\uD328\\uC2A4 25",
    d: "M409.6,12.8a1.519,1.519,0,0,0-1.538-1.229c-1.386,0-1.905,1.18-1.905,2.412,0,1.166.519,2.346,1.905,2.346a1.573,1.573,0,0,0,1.6-1.56h1.5a2.977,2.977,0,0,1-3.1,2.87,3.4,3.4,0,0,1-3.453-3.657,3.413,3.413,0,0,1,3.453-3.71A2.852,2.852,0,0,1,411.1,12.8Z",
    transform: "translate(-306.079 -7.768)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_26",
    "data-name": "\\uD328\\uC2A4 26",
    d: "M435.241,18.468h1.323v.948h.024a1.805,1.805,0,0,1,1.626-1.092,1.725,1.725,0,0,1,.3.049v1.318a1.864,1.864,0,0,0-.5-.054c-1.024,0-1.372.73-1.372,1.638V23.56h-1.4Z",
    transform: "translate(-329.253 -13.862)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27",
    "data-name": "\\uD328\\uC2A4 27",
    d: "M450.637,21.351c.044.879.475,1.291,1.249,1.291a1.161,1.161,0,0,0,1.107-.659h1.229a2.29,2.29,0,0,1-2.381,1.709,2.483,2.483,0,0,1-2.6-2.676,2.559,2.559,0,0,1,2.6-2.692c1.729,0,2.567,1.46,2.469,3.027Zm2.272-.882c-.122-.71-.431-1.092-1.112-1.092a1.109,1.109,0,0,0-1.161,1.092Z",
    transform: "translate(-339.844 -13.862)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_28",
    "data-name": "\\uD328\\uC2A4 28",
    d: "M472.744,20.04c.083-1.318,1.254-1.717,2.4-1.717,1.014,0,2.238.23,2.238,1.447v2.647a2.516,2.516,0,0,0,.181,1.141h-1.43a2.154,2.154,0,0,1-.088-.5,2.351,2.351,0,0,1-1.719.632c-.965,0-1.729-.478-1.729-1.528,0-1.149.867-1.416,1.729-1.536.862-.137,1.656-.1,1.656-.676,0-.6-.411-.691-.9-.691-.539,0-.882.216-.93.779Zm3.233,1.024a2.59,2.59,0,0,1-1.166.294c-.431.1-.823.235-.823.752s.4.647.857.647a1.041,1.041,0,0,0,1.131-1.171Z",
    transform: "translate(-357.509 -13.861)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_29",
    "data-name": "\\uD328\\uC2A4 29",
    d: "M497,14.185h1.023v.94H497v2.518c0,.47.117.59.6.59a1.489,1.489,0,0,0,.426-.049v1.1a5.01,5.01,0,0,1-.818.047c-.847,0-1.6-.2-1.6-1.212v-3h-.843v-.94h.843V12.662H497Z",
    transform: "translate(-374.277 -9.579)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_30",
    "data-name": "\\uD328\\uC2A4 30",
    d: "M512.513,12.112h-1.4V10.961h1.4Zm-1.4.786h1.4V17.99h-1.4Z",
    transform: "translate(-386.648 -8.292)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_31",
    "data-name": "\\uD328\\uC2A4 31",
    d: "M522.7,24.008h-1.562L519.4,18.916h1.469l1.073,3.475h.015l1.077-3.475h1.386Z",
    transform: "translate(-392.917 -14.31)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_32",
    "data-name": "\\uD328\\uC2A4 32",
    d: "M542.8,21.351c.035.879.47,1.291,1.249,1.291a1.14,1.14,0,0,0,1.1-.659h1.229A2.284,2.284,0,0,1,544,23.692a2.483,2.483,0,0,1-2.6-2.676,2.556,2.556,0,0,1,2.6-2.692c1.724,0,2.571,1.46,2.464,3.027Zm2.273-.882c-.132-.71-.431-1.092-1.112-1.092a1.105,1.105,0,0,0-1.161,1.092Z",
    transform: "translate(-409.563 -13.862)",
    fill: "#5a5b5e"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_47",
    "data-name": "\\uADF8\\uB8F9 47",
    transform: "translate(144.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_46",
    "data-name": "\\uADF8\\uB8F9 46",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_34",
    "data-name": "\\uC0AC\\uAC01\\uD615 34",
    width: 19.796,
    height: 31.372,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_49",
    "data-name": "\\uADF8\\uB8F9 49",
    transform: "translate(149.994 16.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_48",
    "data-name": "\\uADF8\\uB8F9 48",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_35",
    "data-name": "\\uC0AC\\uAC01\\uD615 35",
    width: 19.791,
    height: 31.382,
    fill: "url(#linear-gradient-2)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_51",
    "data-name": "\\uADF8\\uB8F9 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_50",
    "data-name": "\\uADF8\\uB8F9 50",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_35",
    "data-name": "\\uD328\\uC2A4 35",
    d: "M24.087,84.769V75.437H19.727v3.194H8.045V75.437H3.716V88.869H20.021c1.8,0,4.065.01,4.065-4.1m-4.359-1.45c0,1.283-.319,1.935-.95,1.935H9.226A1.035,1.035,0,0,1,8.045,84.1V82.227H19.727Zm7.91,7.945a1.35,1.35,0,0,0-.744-.637,2.6,2.6,0,0,0-1-.123,6.971,6.971,0,0,0-1.077.142c-.353.074-.657.152-.921.216-.289.083-.676.2-1.185.362s-1.136.3-1.9.456a26.823,26.823,0,0,1-2.836.446,37.534,37.534,0,0,1-3.894.177c-1.376,0-2.65-.044-3.821-.157s-2.2-.24-3.1-.4-1.651-.3-2.263-.46c-.617-.137-1.038-.274-1.283-.353-.279-.068-.573-.137-.867-.225a5.027,5.027,0,0,0-.872-.137,3.2,3.2,0,0,0-.852.127,1.273,1.273,0,0,0-.691.568,2.015,2.015,0,0,0-.216,1.763,1.888,1.888,0,0,0,1.269,1.161,14.982,14.982,0,0,0,2,.607c.877.24,1.881.465,3,.656s2.361.372,3.693.5c.524.059,1.063.113,1.606.128v8.4h1.9c1.714,0,2.567-1.494,2.567-4.467V96.123c.637-.049,1.264-.113,1.9-.171,1.317-.127,2.527-.294,3.644-.5,1.092-.191,2.052-.407,2.885-.637a14.5,14.5,0,0,0,1.871-.627,1.984,1.984,0,0,0,1.3-1.2,2.315,2.315,0,0,0-.113-1.724",
    transform: "translate(0 -57.067)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36",
    "data-name": "\\uD328\\uC2A4 36",
    d: "M243.7,89.124V85.157h6.774c1.582,0,2.415-.833,2.415-2.522a.759.759,0,0,0,0-.108v-.946H243.7V77.147h7.435c1.969,0,2.444-.837,2.444-2.525V73.535H239.329V89.947c0,2.4,1.234,3.62,3.708,3.62H252.8c1.788,0,2.434-.847,2.449-2.5V89.947H244.516a.724.724,0,0,1-.818-.823m13.484-17.066v29.537h1.386c1.724,0,3.042-.75,3.042-3.218V72.058Z",
    transform: "translate(-181.049 -54.511)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_37",
    "data-name": "\\uD328\\uC2A4 37",
    d: "M476.206,91.19a.05.05,0,0,0-.025-.029,13.754,13.754,0,0,1-3.193-5.192,18.155,18.155,0,0,1-1.18-6.773V76.071h-4.144V79.2a18.239,18.239,0,0,1-1.132,6.616A18.142,18.142,0,0,1,465.4,79.2V76.071h-4.144V79.2a18.055,18.055,0,0,1-1.19,6.773,13.812,13.812,0,0,1-3.551,5.069,1.718,1.718,0,1,0,2.233,2.611l.005,0a16.937,16.937,0,0,0,4.57-5.437,16.721,16.721,0,0,0,.882,1.474.442.442,0,0,1,.034.049c-.4.6-1.044,1.45-1.332,1.871a1.7,1.7,0,0,0-.309,1.4,1.774,1.774,0,0,0,2.469,1.234,5.912,5.912,0,0,0,1.876-1.636c.72-.945,1.288-1.989,1.92-2.939a16.536,16.536,0,0,0,.867-1.455,17.081,17.081,0,0,0,4.114,5.535l0-.005a1.724,1.724,0,0,0,1.146.436,1.751,1.751,0,0,0,1.749-1.739,1.725,1.725,0,0,0-.539-1.254",
    transform: "translate(-344.895 -57.547)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_38",
    "data-name": "\\uD328\\uC2A4 38",
    d: "M544.58,72.058v29.537h1.837c1.381,0,2.567-.416,2.567-3.081V72.058Z",
    transform: "translate(-411.966 -54.511)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_39",
    "data-name": "\\uD328\\uC2A4 39",
    d: "M125.942,82.86a16.289,16.289,0,0,0,5.51,4.918c.769.441,1.474.132,2.131-.916.612-.94.539-1.69-.23-2.229a11.948,11.948,0,0,1-3.933-4.188,10.7,10.7,0,0,1-1.283-5.171V72.881h-4.492v2.393a11.817,11.817,0,0,1-1.268,5.333,11.353,11.353,0,0,1-3.953,4.359c-.745.539-.818,1.288-.23,2.228q1.021,1.573,2.136.906a14.906,14.906,0,0,0,5.613-5.241M140.8,78.788v-6.73h-4.359V90.133s1.944.01,2.038,0h.015v-.005q2.307-.228,2.307-4.442V82.4h2.033a2.2,2.2,0,0,0,2.3-2.41v-1.2Z",
    transform: "translate(-89.116 -54.511)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_40",
    "data-name": "\\uD328\\uC2A4 40",
    d: "M142.054,159.559a10.419,10.419,0,0,1-9.948-7.45,2.147,2.147,0,1,1,4.119-1.215,6.072,6.072,0,0,0,11.662,0,2.147,2.147,0,1,1,4.119,1.215,10.434,10.434,0,0,1-9.953,7.45",
    transform: "translate(-99.869 -112.984)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_41",
    "data-name": "\\uD328\\uC2A4 41",
    d: "M368.355,159.559a10.429,10.429,0,0,1-9.953-7.45,2.15,2.15,0,0,1,4.124-1.215,6.075,6.075,0,0,0,11.667,0,2.145,2.145,0,1,1,4.114,1.215,10.421,10.421,0,0,1-9.953,7.45",
    transform: "translate(-271.061 -112.984)",
    fill: "#5a5b5e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8d4fd9f2e25615a7fb7fc8d9554bc14a.svg";
export { ForwardRef as ReactComponent };